export default __webpack_public_path__ + "static/media/home.2cd9f004.svg";